export default "__VITE_ASSET__86409567__"